import React, { FC, useEffect } from 'react';

import { getProductCompletionSheetsListFetch } from 'src/resources/productCompletionSheetsList/reducer';
import { RootStoreType } from 'src/types/store';
import { useDispatch, useSelector } from 'react-redux';
import translate from '@translate';
import { setLocationParams } from 'src/resources/location/reducer';
import TableSimple from 'src/components/TableSimple';
import { allColumns } from './constants';
import TopBlock from './TopBlock';
import { useCheckPermission } from 'src/utils/checkPermission';
import LaunchIcon from '@mui/icons-material/Launch';

export interface ProductCompletionSheetsListContainerPropsType {}
const ProductCompletionSheetsListContainer: FC<ProductCompletionSheetsListContainerPropsType> = (props) => {
    const dispatch = useDispatch();

    const loading = useSelector((state: RootStoreType) => state.productCompletionSheetsList.loading);
    const productCompletionSheetsData = useSelector((state: RootStoreType) => state.productCompletionSheetsList.data);
    const productCompletionSheetStatusCodes = useSelector(
        (state: RootStoreType) => state.constantsCodes.data.productCompletionSheetStatusCodes
    );

    const permissionCreate = useCheckPermission('PRODUCT_COMPLETION_SHEET.CREATE');
    const permissionDeatil = useCheckPermission('PRODUCT_COMPLETION_SHEET.DETAIL');

    useEffect(() => {
        dispatch(setLocationParams({ name: translate('productCompletionSheets.title') }));
    }, []);

    useEffect(() => {
        if (!productCompletionSheetsData) {
            dispatch(getProductCompletionSheetsListFetch());
        }
    }, [productCompletionSheetsData]);

    const reloadList = () => {
        dispatch(getProductCompletionSheetsListFetch());
    };

    return (
        <>
            <TopBlock reloadList={reloadList} permissionCreate={permissionCreate} />
            <TableSimple
                rowIdKey="ID"
                rows={productCompletionSheetsData || []}
                loading={loading}
                columsLabelPrefix="productCompletionSheets.table"
                allColumns={allColumns}
                initSort={{ column: 'CREATED_AT', direction: 'DESC' }}
                rowActions={[
                    {
                        icon: <LaunchIcon />,
                        label: translate('productCompletionSheets.action.productCompletionSheetDetail'),
                        getLink: (row) => `/commands/product_completion_sheets/${row.ID}/`,
                        hiddenFce: () => !permissionDeatil,
                    },
                ]}
                heightVariant="top-tab"
                fullHeight
                optionsSessionName="productCompletionSheetsTable"
                selectOptions={{ productCompletionSheetStatusCodes }}
            />
        </>
    );
};

export default ProductCompletionSheetsListContainer;
